import { Spinner } from '@platform/components';
import { Control } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';
import { OptionalNote } from './OptionalNote';

type UnresponsiveContentProps = {
  control: Control<UpdateDiscoveryCallFormData>;
  otherPartyName: string;
  isSaving: boolean;
};

export const UnresponsiveContent = (props: UnresponsiveContentProps) => {
  return (
    <div className='flex flex-col gap-4 md:mt-8 items-center md:w-[500px]'>
      {props.isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-lg'>
            Sorry to hear that {props.otherPartyName} has been unresponsive. We'll reach out to them
            to see what's going on, and update you via email.
          </div>
          <OptionalNote
            control={props.control}
            placeholder='Anything else you want to tell us....'
          />
        </>
      }
    </div>
  );
};
